/* Dropdown Menu */

var dropItems = document.querySelectorAll(".main-nav > ul > li");
var mainNav = document.querySelector(".main-nav");
var navButtons = document.querySelectorAll(".header .nav-drop");

var wave = document.querySelector(".feature-wave");
//
var instance = new SV.HoverIntent(dropItems, {
	onEnter: function (targetItem) {
		// called on mouseenter with intent
		targetItem.querySelector(".nav-header").classList.add("active");
		if (!mainNav.hasAttribute("data-spot")) {
			document.body.classList.add("menu-open");
			vSlideDown(targetItem.querySelector(".nav-drop"), 250);
			console.log("SLIDE DOWN");
		} else {
			navButtons.forEach(function (ditem) {
				ditem.style.display = "none";
			});
			targetItem.querySelector(".nav-drop").style.display = "block";
			console.log("SET TO BLOCK");
		}
		setTimeout(() => {
			mainNav.setAttribute("data-spot", indexInParent(targetItem));
		}, 250);
	},
	onExit: function (targetItem) {
		// call on mouseleave after timeout
		if (indexInParent(targetItem) == mainNav.getAttribute("data-spot")) {
			mainNav.removeAttribute("data-spot");
			console.log(targetItem);
			targetItem.querySelector(".nav-header").classList.remove("active");
			vSlideUp(targetItem.querySelector(".nav-drop"), 250);
			document.body.classList.remove("menu-open");
		}
	},
});

let closeBtn = document.getElementsByClassName("js-close-nav");
for (let btn of closeBtn) {
	btn.addEventListener("click", (e) => {
		mainNav.removeAttribute("data-spot");
		document.querySelector(".nav-header").classList.remove("active");
		vSlideUp(e.currentTarget.parentNode.parentNode, 250);
		document.body.classList.remove("menu-open");
	});
}

function indexInParent(node) {
	var children = node.parentNode.childNodes;
	var num = 0;
	for (var i = 0; i < children.length; i++) {
		if (children[i] == node) return num;
		if (children[i].nodeType == 1) num++;
	}
	return -1;
}

function menuHover(el) {
	var interval;
	var outInterval;
	var mel = el.querySelector(".dropdown-area");

	el.addEventListener("mouseleave", function (event) {
		interval = setInterval(function () {
			mel.style.display = "none";
		}, 500);
		if (outInterval) {
			clearInterval(outInterval);
		}
	});

	el.addEventListener("mouseover", function (event) {
		outInterval = setInterval(function () {
			mel.style.display = "block";
		}, 500);
		if (interval) {
			clearInterval(interval);
		}
	});
}

document.addEventListener(
	"click",
	(element) => {
		if (element.target.matches(".drop-content a")) {
			mainNav.removeAttribute("data-spot");
			vSlideUp(
				document
					.querySelector(".nav-header.active")
					.querySelector(".nav-drop"),
				250
			);
			document
				.querySelector(".nav-header.active")
				.classList.remove("active");
			if (wave != null) wave.classList.remove("faded");
		}
	},
	false
);

/*** MAIN NAV ***/
window.addEventListener(
	"hashchange",
	function (event) {
		var drops = document.querySelectorAll(".nav-drop");

		drops.forEach(function (item) {
			item.style.display = "none";
		});

		if (document.querySelector(location.hash).length > 0) {
			if (
				document
					.querySelector(location.hash)
					.classList.contains("js-tab")
			) {
				var hs = document
					.querySelector(location.hash)
					.querySelector("button")
					.click();
			}
		}
	},
	false
);

/*** ALERTS ***/
let alertBell = document.querySelector(".nav-alerts");

if (document.getElementsByClassName("hidden-alert").length >= 1) {
	alertBell.style.visibility = "visible";
}

function getCookie(name) {
	let value = `; ${document.cookie}`;
	let parts = value.split(`; ${name}=`);
	if (parts.length === 2) {
		return parts.pop().split(";").shift();
	} else {
		return null;
	}
}
document.addEventListener(
	"click",
	(element) => {
		if (element.target.matches(".js-close-alert")) {
			element.target.parentNode.classList.add("hidden-alert");
			var cook =
				getCookie("alerts") +
				"|" +
				event.target.parentNode.getAttribute("data-alert-id") +
				"|";
			document.cookie =
				"alerts=" +
				cook +
				"; path=/; max-age=" +
				60 * 60 * 24 * 14 +
				";";

			vSlideUp(element.target.parentNode);
			alertBell.style.visibility = "visible";
		}
	},
	false
);

/*** SCRIPT ANIMATIONS ***/
let observer = new IntersectionObserver(function (entries) {
	entries.forEach(function (entry) {
		// Log if the element and if it's in the viewport
		if (entry.target.matches(".brick-split")) {
			if (entry.isIntersecting) {
				entry.target.timer = setInterval(function () {
					entry.target.style.backgroundPosition =
						120 -
						-20 *
							(entry.target.getBoundingClientRect().top /
								entry.target.offsetHeight) +
						"% 0";
				}, 30);
			} else {
				clearInterval(entry.target.timer);
			}
		}
	});
});

/******* COUNTER ON SCROLL **********/
// How long you want the animation to take, in ms
const animationDuration = 2000;
// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
const frameDuration = 1000 / 60;
// Use that to calculate how many frames we need to complete the animation
const totalFrames = Math.round(animationDuration / frameDuration);
// An ease-out function that slows the count as it progresses
const easeOutQuad = (t) => t * (2 - t);

// The animation function, which takes an Element
const animateCountUp = (el) => {
	let frame = 0;
	const countTo = parseInt(el.innerHTML.replace(",", ""), 10);
	// Start the animation running 60 times per second
	const counter = setInterval(() => {
		frame++;
		// Calculate our progress as a value between 0 and 1
		// Pass that value to our easing function to get our
		// progress on a curve
		const progress = easeOutQuad(frame / totalFrames);
		// Use the progress value to calculate the current count
		const currentCount = Math.round(countTo * progress);

		// If the current count has changed, update the element
		if (parseInt(el.innerHTML.replace(",", ""), 10) !== currentCount) {
			el.innerHTML = currentCount
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}

		// If we’ve reached our last frame, stop the animation
		if (frame === totalFrames) {
			clearInterval(counter);
		}
	}, frameDuration);
};

/*** SCROLL ANIMATIONS ***/
let scrollObserver = new IntersectionObserver(
	function (entries) {
		entries.forEach(function (entry) {
			if (entry.target.matches(".scroll")) {
				if (entry.isIntersecting) {
					entry.target.classList.add("active");
					if (entry.target.matches(".count")) {
						animateCountUp(entry.target);
					}
				}
			}
		});
	},
	{ threshold: 0.3 }
);

/*** STICKY HEADER ***/
// get the sticky element
const stickyElm = document.querySelector(".headers");

const stickyObserver = new IntersectionObserver(
	function (entries) {
		entries.forEach(function (entry) {
			entry.target.classList.toggle(
				"isSticky",
				entry.intersectionRatio < 1
			);
			console.log("STICKY: " + entry.intersectionRatio);
		});
	},
	{ threshold: [1] }
);
stickyObserver.observe(stickyElm);

let scrolls = document.querySelectorAll(".scroll");

scrolls.forEach(function (item) {
	scrollObserver.observe(item);
});

/** STICKY SIDEBAR ***/
var sbObserver = new IntersectionObserver(
	function (entries) {
		entries.forEach(function (entry) {
			if (entry.boundingClientRect.top < 400) {
				//if it hits top of viewport
				var sidebarSearch = document.querySelector(".sidebar-search");
				if (entry.intersectionRatio < 1) {
					vSlideDown(sidebarSearch);
				} else {
					vSlideUp(sidebarSearch);
				}
			}
		});
	},
	{ rootMargin: "-180px 0px 0px 0px", threshold: [1] }
);
// The element to observe
let sbs = document.querySelectorAll(".sidebar");
// Attach it to the observer
sbs.forEach(function (item) {
	sbObserver.observe(item);
});

/*** ESCAPE KEY CLOSURES ***/
document.onkeydown = function (e) {
	e = e || window.event;
	if (e.key === "Escape" || e.key === "Esc") {
		if (
			document.querySelector(".js-search-area").style.display == "block"
		) {
			document.querySelector(".js-search-close").click();
		}
		if (document.querySelector(".js-login-area").style.display == "block") {
			document.querySelector(".js-login").click();
		}
	}
};

var body = document.querySelector("body");

/*** Search Window ***/
document.addEventListener(
	"click",
	function (e) {
		//Search Open
		if (e.target.matches(".js-search")) {
			if (body.classList.contains("login-open")) {
				document.querySelector(".js-login").click();
			}

			var btn = document.querySelector(".js-search-area");
			if (btn.style.display !== "block") {
				vSlideDown(btn);
				document.body.classList.add("menu-open");

				body.classList.add("search-open");
				if (body.classList.contains("login-open")) {
					document.querySelector(".js-login").click();
				}
				if (
					document
						.querySelector(".js-nav-mobile")
						.classList.contains("open")
				) {
					document.querySelector(".js-nav-mobile").click();
				}
				var searchBox = document.querySelector(
					".header-search .search-key"
				);
				searchBox.focus();

				if (window.innerWidget < 900) {
					window.scrollTo({ top: 0, behavior: "smooth" });
				}
				document
					.querySelector(".js-search")
					.classList.add("js-search-close");
				document
					.querySelector(".js-search")
					.classList.remove("js-search");
			}
		}
		//Search Close
		else if (e.target.matches(".js-search-close")) {
			var btn = document.querySelector(".js-search-area");
			vSlideUp(btn);
			document.body.classList.remove("menu-open");
			body.classList.remove("search-open");

			if (e.target.classList.contains("login-btn")) {
				e.target.querySelector("img").src =
					"/wp-content/uploads/2022/04/ico-head_padlock.svg";
				e.target.querySelector("span").innerText(" Account Login");
			}
			document
				.querySelector(".js-search-close")
				.classList.add("js-search");
			document
				.querySelector(".js-search-close")
				.classList.remove("js-search-close");
		}
		//Login Open
		else if (e.target.matches(".js-login")) {
			if (
				document.querySelector(".js-search-area").style.display ==
				"block"
			) {
				document.querySelector(".js-search-close").click();
			}
			var btn = document.querySelector(".js-login-area");

			if (body.classList.contains("login-open")) {
				vSlideUp(btn);
				document.body.classList.remove("menu-open");
				body.classList.remove("login-open");

				if (e.target.classList.contains("login-btn")) {
					e.target.querySelector("img").src =
						"/wp-content/uploads/2022/04/ico-head_padlock.svg";
					e.target.querySelector("span").innerText = " Account Login";
					e.target.classList.remove("open");
				}
			} else {
				vSlideDown(btn);
				document.body.classList.add("menu-open");
				body.classList.add("login-open");

				var loginBox = document.querySelector(".personal-form #userid");
				if (loginBox) {
					loginBox.focus();
				}

				if (body.classList.contains("search-open")) {
					document.querySelector(".js-search-close").click();
				}

				if (e.target.classList.contains("login-btn")) {
					e.target.querySelector("img").src =
						"/wp-content/uploads/2022/04/ico-close.svg";
					e.target.querySelector("span").innerText = " Close";
					e.target.classList.add("open");
				}
			}

			if (e.target.classList.contains("login-mobile")) {
				if (!e.target.classList.contains("active")) {
					e.target.querySelector("img").src =
						"/wp-content/uploads/2022/04/ico-close.svg";
					e.target
						.querySelector("img")
						.setAttribute("alt", "Close Login");
					e.target.classList.add("active");
				} else {
					e.target.querySelector("img").src =
						"/wp-content/uploads/2022/04/ico-head_padlock.svg";
					e.target
						.querySelector("img")
						.setAttribute("alt", "Open Login");
					e.target.classList.remove("active");
				}
				vSlideUp(document.querySelector(".js-mobile-nav-area"));
				document
					.querySelector(".js-nav-mobile")
					.classList.remove("open");
			}
		}
		//Login Close
		else if (e.target.matches(".js-login-close")) {
			var btn = document.querySelector(".js-login-area");
			vSlideUp(btn);
			document.body.classList.remove("menu-open");
			body.classList.remove("login-open");
		}
		//Login Mobile Dropdown
		else if (e.target.matches(".js-login-drop")) {
			var btn = e.target.parentNode.querySelector("ul");
			if (btn.style.display != "block") {
				vSlideDown(btn); //.style.display = "block";
				e.target.parentNode.classList.add("active");
			} else {
				vSlideUp(btn); //btn.style.display = "none";
				e.target.parentNode.classList.remove("active");
			}
		}
		//Personal Login Tab
		else if (e.target.matches(".js-login-personal")) {
			document
				.querySelector("#mobile-personal-form")
				.classList.add("active");
			document.querySelector(".mobile-tabs").classList.add("active");
			document.querySelector(".js-login-back").classList.add("active");
		}
		//Business Login Tab
		else if (e.target.matches(".js-login-business")) {
			document
				.querySelector("#mobile-business-form")
				.classList.add("active");
			document.querySelector(".mobile-tabs").classList.add("active");
			document.querySelector(".js-login-back").classList.add("active");
		}
		//Additional Login Tab
		else if (e.target.matches(".js-login-additional")) {
			document
				.querySelector(".additional-logins")
				.classList.add("active");
			document.querySelector(".mobile-tabs").classList.add("active");
			document.querySelector(".js-login-back").classList.add("active");
		}
		//Additional Login Tab
		else if (e.target.matches(".js-login-back")) {
			document
				.querySelector(".additional-logins")
				.classList.remove("active");
			document
				.querySelector("#mobile-personal-form")
				.classList.remove("active");
			document
				.querySelector("#mobile-business-form")
				.classList.remove("active");
			document.querySelector(".mobile-tabs").classList.remove("active");
			document.querySelector(".js-login-back").classList.remove("active");
		}
		//Mobile Nav Open
		else if (e.target.matches(".js-nav-mobile")) {
			if (
				document
					.querySelector(".js-login.login-mobile")
					.classList.contains("active")
			) {
				document
					.querySelector(".js-login.login-mobile")
					.classList.remove("active");
				vSlideUp(document.querySelector(".nav-flyout.js-login-area"));
				document.querySelector(
					".js-login.login-mobile"
				).firstChild.src =
					"/wp-content/uploads/2022/04/ico-head_padlock.svg";
				document.body.classList.remove("menu-open");
				document.body.classList.remove("login-open");
			}
			var btn = document.querySelector(".js-mobile-nav-area");
			if (e.target.classList.contains("open")) {
				vSlideUp(btn);
				e.target.classList.remove("open");
			} else {
				vSlideDown(btn);
				e.target.classList.add("open");
				e.target.parentNode.classList.add("open");
			}
		} else if (e.target.matches(".js-mobile-close")) {
			jQuery(".mobile-nav>ul>li").removeClass("active");
			jQuery(".mobile-nav .nav-drop").hide();
			window.scrollTo({ top: 0, behavior: "smooth" });
		}
		//Mobile Dropdown/Accordion
		else if (e.target.matches(".js-mobile-dropdown-btn")) {
			var content = e.target.parentNode.querySelector(
				".js-mobile-dropdown-content"
			);
			var dropButton = e.target;
			if (dropButton.classList.contains("open")) {
				dropButton.classList.remove("open");
				vSlideUp(content);
			} else {
				dropButton.classList.add("open");
				vSlideDown(content);
			}
		} else if (e.target.matches(".js-accordion-button")) {
			var cnt = e.target.parentNode.querySelector(
				".js-accordion-content"
			);
			if (e.target.parentNode.classList.contains("open")) {
				e.target.parentNode.classList.remove("open");
				vSlideUp(cnt);
			} else {
				e.target.parentNode.classList.add("open");
				vSlideDown(cnt);
			}
		}

		//CTA - Accordion Logic
		else if (e.target.matches(".js-ctas")) {
			var cnt = e.target.parentNode.querySelector(".ctas");
			if (e.target.parentNode.classList.contains("open")) {
				e.target.parentNode.classList.remove("open");
				vSlideUp(cnt);
			} else {
				e.target.parentNode.classList.add("open");
				vSlideDown(cnt);
			}
		}
		//Mobile Nav Close
		else if (e.target.matches(".js-nav-mobile-close")) {
			var btn = document.querySelector(".js-mobile-nav-area");
			vSlideUp(btn);
		}
		//Mobile Drop
		else if (e.target.matches(".mobile-nav > ul > li > button")) {
			var btn = e.target.parentNode.querySelector(".nav-drop");
			if (btn.style.display != "block") {
				vSlideDown(btn); //.style.display = "block";
				e.target.parentNode.classList.add("active");
			} else {
				vSlideUp(btn); //btn.style.display = "none";
				e.target.parentNode.classList.remove("active");
			}
		} else if (
			e.target.matches(
				".mobile-nav .nav-drop .drop-content > ul > li > button"
			)
		) {
			var btn = e.target.parentNode.querySelector("ul");
			if (btn.style.display != "block") {
				vSlideDown(btn); //.style.display = "block";
				e.target.parentNode.classList.add("active");
			} else {
				vSlideUp(btn); //btn.style.display = "none";
				e.target.parentNode.classList.remove("active");
			}
		} else if (e.target.matches(".footer-nav > ul > li > a")) {
			if (window.innerWidth < 900) {
				e.preventDefault();
				var btn = e.target.parentNode.querySelector("ul");
				if (btn.style.display != "block") {
					vSlideDown(btn); //.style.display = "block";
					e.target.parentNode.classList.add("active");
				} else {
					vSlideUp(btn); //btn.style.display = "none";
					e.target.parentNode.classList.remove("active");
				}
			}
		} else if (e.target.matches(".js-accordion-header")) {
			var cnt = e.target.parentNode.parentNode.parentNode.querySelector(
				".js-accordion-content"
			);
			e.target.parentNode.parentNode.parentNode.classList.add("open");
			vSlideDown(cnt);
		} else if (e.target.matches(".js-accordion-close")) {
			var cnt = e.target.parentNode.parentNode.parentNode.querySelector(
				".js-accordion-content"
			);
			e.target.parentNode.parentNode.parentNode.classList.remove("open");
			vSlideUp(cnt);
		} else if (e.target.matches(".js-tab-header")) {
			//change tab

			var tabs = document.querySelectorAll(".js-tab");
			tabs.forEach(function (tab) {
				if (
					tab.getAttribute("data-tab") ==
					e.target.getAttribute("data-tab")
				) {
					tab.classList.add("active");
				} else {
					tab.classList.remove("active");
				}
			});
			var headers = document.querySelectorAll(".js-tab-header");
			headers.forEach(function (tab) {
				if (
					tab.getAttribute("data-tab") ==
					e.target.getAttribute("data-tab")
				) {
					tab.classList.add("active");
				} else {
					tab.classList.remove("active");
				}
			});
		} else if (e.target.matches(".tab-name")) {
			//change tab

			var tab = e.target.parentNode.querySelector(".tab-content");

			if (tab.classList.contains("tab-open")) {
				vSlideUp(tab);
				tab.classList.remove("tab-open");
			} else {
				vSlideDown(tab);
				tab.classList.add("tab-open");
			}
		} else if (e.target.matches(".js-branch-selector")) {
			//Show Locations Modal

			var modal = document.querySelector(".js-branch-modal");

			modal.style.display = "flex";
		} else if (e.target.matches(".js-branch-modal-close")) {
			//Hide Locations Modal

			var modal = document.querySelector(".js-branch-modal");

			modal.style.display = "none";
		} else if (e.target.matches(".js-branch-modal")) {
			//Hide Locations Modal
			if (e.target.id == "locationsModal") {
				var modal = document.querySelector(".js-branch-modal");

				modal.style.display = "none";
			}
		} else if (e.target.matches(".js-location")) {
			//Update for actual locations - save location and id as cookies
			var cook = event.target.innerText;
			var cookID = event.target.getAttribute("data-id");
			document.cookie =
				"locationID=" +
				cookID +
				"; path=/; max-age=" +
				60 * 60 * 24 * 14 +
				";";
			document.cookie =
				"locationName=" +
				cook +
				"; path=/; max-age=" +
				60 * 60 * 24 * 14 +
				";";

			window.location.reload();
		} else if (e.target.matches(".js-sidebar-btn")) {
			//Blog subscribe box on mobile
			vSlideUp(e.target);
			vSlideDown(e.target.parentNode.querySelector(".sidebar-content"));
		} else if (e.target.matches(".js-sidebar-close-btn")) {
			//Blog subscribe box on mobile
			vSlideUp(e.target.parentNode);
			vSlideDown(
				e.target.parentNode.parentNode.querySelector(".js-sidebar-btn")
			);
		} else if (e.target.matches(".js-alert-bell")) {
			var alerts = document.getElementsByClassName("alert");
			for (let alert of alerts) {
				if (alert.classList.contains("hidden-alert")) {
					vSlideDown(alert);
					alert.classList.remove("hidden-alert");
				}
			}
			document.cookie =
				"alerts=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
			document.querySelector(".js-alert-bell").style.visibility =
				"hidden";
		} else if (e.target.matches(".js-bc-video")) {
			//document.querySelector(".js-bc-video").parentNode.parentNode.parentNode.querySelector("img").click();
			e.target.parentNode.parentNode.parentNode
				.querySelector(".photo img")
				.click();
		} else if (e.target.matches(".jump-lnk")) {
			var btn = document.querySelectorAll(
				"[data-jumplink='" + e.target.innerText + "']"
			);
			if (btn.length > 0) {
				btn[0].scrollIntoView();
			}
			e.target.parentNode.parentNode
				.querySelector(".js-close-jump")
				.click();
		}
		// Comparison Chart Mobile Previous
		else if (e.target.matches(".js-table-prev")) {
			var base = e.target.parentNode.parentNode; //$(this).parent().parent();
			base.querySelector(".js-table-next").classList.remove("grayed");
			base.setAttribute(
				"data-col",
				Number(base.getAttribute("data-col")) - 1
			);
			if (base.getAttribute("data-col") == 1) {
				e.target.classList.add("grayed");
			}
			var spot = base.querySelector("table tr");
			var ths = spot.querySelectorAll("th");
			base.querySelector(".js-rate-head").innerHTML = eq.call(
				ths,
				base.getAttribute("data-col")
			).innerHTML;
		}
		// Comparison Chart Mobile Next
		else if (e.target.matches(".js-table-next")) {
			var base = e.target.parentNode.parentNode; //$(this).parent().parent();
			base.querySelector(".js-table-prev").classList.remove("grayed");
			base.setAttribute(
				"data-col",
				Number(base.getAttribute("data-col")) + 1
			);
			var spot = base.querySelector("table tr");
			var ths = spot.querySelectorAll("th");

			if (base.getAttribute("data-col") == ths.length - 1) {
				e.target.classList.add("grayed");
			}

			base.querySelector(".js-rate-head").innerHTML = eq.call(
				ths,
				base.getAttribute("data-col")
			).innerHTML;
		} else if (e.target.matches(".js-location-filter")) {
			jQuery(".noLocations").remove();
			const filter = e.target.dataset.county;

			const buttons =
				document.getElementsByClassName("js-location-filter");

			for (button of buttons) {
				button.classList = "js-location-filter";
				if (button.dataset.county === filter) {
					button.classList.add("active");
				}
			}
			let locations = document.getElementsByClassName("js-location");

			console.log(`Filtering for ${filter}`);

			jQuery(locations).hide();

			if (filter === "all") {
				jQuery(locations).fadeIn();
			}

			for (locale of locations) {
				if (
					locale.dataset.county === filter &&
					locale.style.display == "none"
				) {
					jQuery(locale).fadeIn();
				}
				// locale.style.display = 'block';
				// locale.classList.remove('fade')
			}
			jQuery(".locations>.content").each(function () {
				let locationsPresent = false;

				jQuery(this)
					.children()
					.each((idx, elt) => {
						if (jQuery(elt).css("display") != "none") {
							locationsPresent = true;
						}
					});
				if (!locationsPresent) {
					jQuery(this).append(
						'<h2 class="noLocations">No Locations Found in this County</h2>'
					);
				}
			});
			e.target.scrollIntoView();
		} else if (e.target.matches(".js-directory-filter")) {

			const filter = e.target.dataset.county;

			const buttons =
				document.getElementsByClassName("js-directory-filter");

			for (button of buttons) {
				button.classList = "js-directory-filter";
				if (button.dataset.county === filter) {
					button.classList.add("active");
				}
			}

			if(filter != 'all'){				
				jQuery('.lenders-grid .lender-box').hide();
				jQuery('.lenders-grid .lender-box.' + filter).show();
			} else {				
				jQuery('.lenders-grid .lender-box').show();
			}


		} else if (e.target.matches(".js-anchor")) {
			let anchorID = e.target.href.split("#")[1];

			let accordion = document.getElementById(anchorID);
			accordion.parentNode.classList.add("open");
			vSlideDown(accordion.nextElementSibling);

			window.location.hash = "";
			window.location.hash = "#" + anchorID;
		}
	},
	false
);

/** masked text **/
var masks = document.querySelectorAll(".f-screen");

masks.forEach(function (mask) {
	mask.setAttribute("data-text", mask.innerText);
});

/** Tabs **/
var tabs = document.querySelectorAll(".tab-area.js-tab");
//Create Tab Nav
var tabHeader = document.createElement("div");
tabHeader.classList.add("tabs-nav");
var cnt = document.createElement("div");
cnt.classList.add("content");
tabs.forEach(function (tab) {
	var rand = Math.floor(Math.random() * 10000000000000);
	var btn = document.createElement("button");
	btn.classList.add("js-tab-header");
	btn.setAttribute("data-tab", rand);
	tab.setAttribute("data-tab", rand);
	btn.innerHTML = tab.querySelector(".tab-name").innerHTML;
	tab.querySelector(".tab-name").style.display = "none";
	cnt.appendChild(btn);
});
tabHeader.appendChild(cnt);

if (tabs.length > 0) {
	tabs[0].parentNode.insertBefore(tabHeader, tabs[0]);
}

//Set first as active
var tabBtns = document.querySelectorAll(".js-tab-header");
if (tabBtns.length > 0) {
	tabBtns[0].classList.add("active");
	tabs[0].classList.add("active");
}

//Allow setting of tab via location hash
if (window.location.hash) {
	var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character

	tabBtns.forEach(function (topic) {
		if (
			topic.innerText.toLowerCase().replace(/[^a-zA-Z0-9]+/g, "") ==
			hash.toLowerCase().replace(/[^a-zA-Z0-9]+/g, "")
		) {
			topic.click();
		}
	});
}

(function (document, history, location) {
	var HISTORY_SUPPORT = !!(history && history.pushState);

	var anchorScrolls = {
		ANCHOR_REGEX: /^#[^ ]+$/,
		OFFSET_HEIGHT_PX: 65,

		/**
		 * Establish events, and fix initial scroll position if a hash is provided.
		 */
		init: function () {
			this.scrollToCurrent();
			window.addEventListener(
				"hashchange",
				this.scrollToCurrent.bind(this)
			);
			document.body.addEventListener(
				"click",
				this.delegateAnchors.bind(this)
			);
		},

		/**
		 * Return the offset amount to deduct from the normal scroll position.
		 * Modify as appropriate to allow for dynamic calculations
		 */
		getFixedOffset: function () {
			return this.OFFSET_HEIGHT_PX;
		},

		/**
		 * If the provided href is an anchor which resolves to an element on the
		 * page, scroll to it.
		 * @param  {String} href
		 * @return {Boolean} - Was the href an anchor.
		 */
		scrollIfAnchor: function (href, pushToHistory) {
			var match, rect, anchorOffset;

			if (!this.ANCHOR_REGEX.test(href)) {
				return false;
			}

			match = document.getElementById(href.slice(1));

			if (match) {
				rect = match.getBoundingClientRect();
				anchorOffset =
					window.pageYOffset + rect.top - this.getFixedOffset();
				window.scrollTo({
					top: anchorOffset,
					left: window.pageXOffset,
					behavior: "smooth",
				});

				// Add the state to history as-per normal anchor links
				if (HISTORY_SUPPORT && pushToHistory) {
					history.pushState(
						{},
						document.title,
						location.pathname + href
					);
				}
			}

			return !!match;
		},

		/**
		 * Attempt to scroll to the current location's hash.
		 */
		scrollToCurrent: function () {
			this.scrollIfAnchor(window.location.hash);
		},

		/**
		 * If the click event's target was an anchor, fix the scroll position.
		 */
		delegateAnchors: function (e) {
			var elem = e.target;

			if (
				elem.nodeName === "A" &&
				this.scrollIfAnchor(elem.getAttribute("href"), true)
			) {
				e.preventDefault();
			}
		},
	};

	window.addEventListener(
		"DOMContentLoaded",
		anchorScrolls.init.bind(anchorScrolls)
	);
})(window.document, window.history, window.location);

/** CAROUSELS **/

document.addEventListener("DOMContentLoaded", function () {
	let slides = document.querySelectorAll(".splide__slide");

	for (slide of slides) {
		slide.parentNode.classList.add("splide__slide");
	}

	var carousels = document.querySelectorAll(".splide");

	if (carousels.length > 0) {
		var splide = new Splide(".splide", {
			// perPage: 1,
			width: "100%",
			// type: 'loop',
			drag: true,
			mediaQuery: "min",
			arrows: false,
			breakpoints: {
				900: {
					//   pagination: false,
					gap: 30,
					destroy: true,
				},
			},
		});
		splide.mount();
	}

	//COOKIE LOCATION
	if (getCookie("locationID") != null) {
		var locs = document.querySelectorAll(".js-current-branch");

		locs.forEach(function (loc) {
			loc.innerText = getCookie("locationName");
			loc.setAttribute("data-id", getCookie("locationID"));
		});
	}

	//Compare Chart Highlight
	var cmp = document.querySelectorAll(".compare-table");

	if (cmp.length > 0) {
		var pageTitle = document.querySelector("h1");
		if (pageTitle != null) {
			cmp.forEach(function (table) {
				var ths = table.querySelectorAll("th");
				ths.forEach(function (th) {
					if (th.innerText == pageTitle.innerText) {
						var cellIndex = th.cellIndex;

						var tds = table.querySelectorAll("th,td");
						tds.forEach(function (td) {
							if (td.cellIndex == cellIndex) {
								td.classList.add("active");
							}
						});
					}
				});
			});
		}
	}
});

/**
 * ADA - Remove id=pasted
 */
var ids = document.querySelectorAll("#isPasted");
ids.forEach(function (item) {
	item.removeAttribute("id");
});

/** Comparison Charts
 * Add controls on mobile **/
function eq(index) {
	if (index >= 0 && index < this.length) return this[index];
	else return -1;
}

var charts = document.querySelectorAll(".comparison-chart");

charts.forEach(function (chart) {
	var tab = chart.querySelector("table");

	var holder = chart.querySelector(".compare-table");
	var ths = tab.querySelector("tr").querySelectorAll("th");
	if (ths.length > 1) {
		holder.setAttribute("data-col", "1");
		var controls = document.createElement("div");
		controls.classList.add("table-controls");
		controls.innerHTML =
			"<button class='js-table-prev grayed'></button><span class='f-h2 js-rate-head'>" +
			eq.call(ths, 1).innerHTML +
			"</span><button class='js-table-next'></button>";

		holder.insertBefore(controls, holder.firstChild);
	}
});

/** JUMP NAVS ***/
var jumpObserver = new IntersectionObserver(
	function (entries) {
		entries.forEach(function (entry) {
			if (entry.target.matches(".jump-nav")) {
				if (entry.boundingClientRect.top < 200)
					//if it hits top of viewport
					entry.target.classList.toggle(
						"sticky",
						entry.intersectionRatio < 1
					);
			} else if (entry.target.matches("[data-jumplink]")) {
				if (entry.isIntersecting) {
					var jumps = document.querySelectorAll(
						".js-links .jump-lnk"
					);
					jumps.forEach(function (jp) {
						if (
							jp.innerText ==
							entry.target
								.getAttribute("data-jumplink")
								.replace(/_/g, " ")
						) {
							jp.classList.add("active");
						} else {
							jp.classList.remove("active");
						}
					});
				}
			}
		});
	},
	{ rootMargin: "-94px 0px 0px 0px", threshold: [1] }
);
// The element to observe
let jumps = document.querySelectorAll(".jump-nav");
// Attach it to the observer
jumps.forEach(function (item) {
	jumpObserver.observe(item);
});

/*
window.addEventListener('load', function(){
    var carousels = document.querySelectorAll(".mobile-carousel");
   // carousels.forEach(function(item) {
        new Glider(document.querySelector(".mobile-carousel"), {
          slidesToShow: 1,
          dots: '#dots',
          draggable: false,
          scrollLock: true,
          arrows: {
            prev: '.glider-prev',
            next: '.glider-next'
          }
        });
   // });
});
*/

(function (document, history, location) {
	if (!document.querySelector(".branch-sticky")) {
		return;
	}
	var HISTORY_SUPPORT = !!(history && history.pushState);

	var anchorScrolls = {
		ANCHOR_REGEX: /^#[^ ]+$/,
		OFFSET_HEIGHT_PX: 87,

		/**
		 * Establish events, and fix initial scroll position if a hash is provided.
		 */
		init: function () {
			this.scrollToCurrent();
			window.addEventListener(
				"hashchange",
				this.scrollToCurrent.bind(this)
			);
			document.body.addEventListener(
				"click",
				this.delegateAnchors.bind(this)
			);
		},

		/**
		 * Return the offset amount to deduct from the normal scroll position.
		 * Modify as appropriate to allow for dynamic calculations
		 */
		getFixedOffset: function () {
			return this.OFFSET_HEIGHT_PX;
		},

		/**
		 * If the provided href is an anchor which resolves to an element on the
		 * page, scroll to it.
		 * @param  {String} href
		 * @return {Boolean} - Was the href an anchor.
		 */
		scrollIfAnchor: function (href, pushToHistory) {
			var match, rect, anchorOffset;

			if (!this.ANCHOR_REGEX.test(href)) {
				return false;
			}

			match = document.getElementById(href.slice(1));

			if (match) {
				rect = match.getBoundingClientRect();
				anchorOffset =
					window.pageYOffset + rect.top - this.getFixedOffset();
				window.scrollTo({
					top: anchorOffset,
					left: window.pageXOffset,
					behavior: "smooth",
				});

				// Add the state to history as-per normal anchor links
				if (HISTORY_SUPPORT && pushToHistory) {
					history.pushState(
						{},
						document.title,
						location.pathname + href
					);
				}
			}

			return !!match;
		},

		/**
		 * Attempt to scroll to the current location's hash.
		 */
		scrollToCurrent: function () {
			this.scrollIfAnchor(window.location.hash);
		},

		/**
		 * If the click event's target was an anchor, fix the scroll position.
		 */
		delegateAnchors: function (e) {
			var elem = e.target;

			if (
				elem.nodeName === "A" &&
				this.scrollIfAnchor(elem.getAttribute("href"), true)
			) {
				e.preventDefault();
			}
		},
	};

	window.addEventListener(
		"DOMContentLoaded",
		anchorScrolls.init.bind(anchorScrolls)
	);
})(window.document, window.history, window.location);

let footerChat = document.querySelectorAll('.footer-chat');

footerChat.forEach(function (el) {
	if(null != el) {
		el.firstChild.setAttribute("target", "_blank");
		el.firstChild.setAttribute(
			"onclick",
			`window.open(this.href,"popupwindow", "width=500,height=600,left=150,top=100,scrollbars,toolbar=0,resizable");
	    return false`
		);
		el.firstChild.classList.add("no-speedbump");
	}
});

if (document.querySelector(".screen-reader-response>ul")) {
	document.querySelector(".screen-reader-response>ul").remove();
}
jQuery("body").on("click", "a[data-video]", function (e) {
	if ("" != jQuery(this).attr("data-video")) {
		e.preventDefault();
		var t =
			"<div class='video-modal'><div class='video-modal-content'><button class='video-modal-close'>&times;<span class='visuallyhidden'> close</span></button>";
		if (-1 != jQuery(this).attr("data-video").indexOf("vimeo")) {
			var a = jQuery(this)
				.attr("data-video")
				.replace("https://vimeo.com/", "");
			-1 != a.indexOf("/") && (a = a.substring(0, a.indexOf("/"))),
				(t +=
					"<div style='padding: 56.25% 0 0 0; position: relative; '><iframe src='https://player.vimeo.com/video/" +
					a +
					"?title=0&byline=0&portrait=0' style='position:absolute;top:0;left:0;width:100%;height:100%;' frameborder='0' allow='autoplay; fullscreen' allowfullscreen></iframe></div><script src='https://player.vimeo.com/api/player.js'></script>");
		} else if (jQuery(this).attr("data-video").indexOf("youtube")) {
			var a = jQuery(this)
				.attr("data-video")
				.replace("https://www.youtube.com/watch?v=", "");
			-1 != a.indexOf("/") && (a = a.substring(0, a.indexOf("/"))),
				(t +=
					"<div style='padding: 56.25% 0 0 0; position: relative; '><iframe src='https://www.youtube.com/embed/" +
					a +
					"' style='position:absolute;top:0;left:0;width:100%;height:100%;' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen' allowfullscreen></iframe></div>");
		} else
			jQuery(this).attr("data-video").indexOf(".mp4") &&
				(t +=
					"<video width='100%' controls autoplay><source src='" +
					jQuery(this).attr("data-video") +
					"' type='video/mp4'></video>");
		(t += "</div></div>"),
			jQuery(".video-modal").remove(),
			jQuery("body").append(t);
	}
}),
	jQuery("body").on("click", ".video-modal", function (e) {
		jQuery(".video-modal").remove();
	}),
	jQuery("body").on("click", ".video-modal-content", function (e) {
		e.stopPropagation();
	}),
	jQuery("body").on("click", ".video-modal-close", function (e) {
		e.preventDefault(), jQuery(".video-modal").remove();
	});

//comparison table logic
const URLHASH = window.location.hash;
let urlHashAccordion = "";
function initComparisonTables() {
	let t = !1,
		e = document.querySelectorAll(
			'.js-comparison-table:not([data-init="true"])'
		);
	return (
		null !== e &&
			e.length &&
			((t = !0),
			e.forEach(function (t, e) {
				t.querySelector(".js-table-container");
				let n = t.querySelector(".table-controls-dots"),
					r = t.querySelectorAll(
						".mod-comparison-table table tr:first-child th"
					).length,
					a = t.querySelectorAll(".mod-comparison-table tr"),
					l = [],
					o = t.querySelector(".js-account-title");
				for (
					t
						.querySelector(".js-prev-account")
						.addEventListener("click", function (t) {
							let e = getParentElementWithClass(
								t.target,
								"js-comparison-table"
							);
							tablePrev(
								e,
								parseInt(
									e.getAttribute("data-current-position")
								)
							);
						}),
						t
							.querySelector(".js-next-account")
							.addEventListener("click", function (t) {
								let e = getParentElementWithClass(
									t.target,
									"js-comparison-table"
								);
								tableNext(
									e,
									parseInt(
										e.getAttribute("data-current-position")
									)
								);
							}),
						i = 1;
					i < r;
					i++
				)
					l.push(a[0].querySelectorAll("th")[i].innerText),
						t
							.querySelectorAll(
								".mod-comparison-table tr > *:nth-child(" +
									(i + 1) +
									")"
							)
							.forEach(function (t, e) {
								t.setAttribute("data-pos", i);
							}),
						1 == i && (o.innerText = l[i - 1]);
				l.forEach(function (t, e) {
					let i = document.createElement("li"),
						r = "";
					0 == e && (r = " is-active"),
						(i.innerHTML =
							'<button class="carousel-dot js-carousel-dot' +
							r +
							'" type="button" data-pos="' +
							(e + 1) +
							'"><span class="visuallyhidden">View ' +
							t +
							" Features</span>" +
							(e + 1) +
							"</button>"),
						n.append(i),
						i.addEventListener("click", function (t) {
							tableSwitch(
								getParentElementWithClass(
									t.target,
									"js-comparison-table"
								),
								parseInt(t.target.getAttribute("data-pos"))
							);
						});
				}),
					t
						.querySelectorAll(
							".mod-comparison-table tr > *:nth-child(2)"
						)
						.forEach(function (t, e) {
							t.classList.add("active");
						}),
					// addNextButtonAndCTABlock();
					// turnOnDotArrows();
					// populateCTABlock();
					t.setAttribute("data-init", "true"),
					t.setAttribute("data-current-position", 1);
			})),
		t
	);
}
// function addNextButtonAndCTABlock() {
//
//   let element = document.createElement("li");
//   element.innerHTML = `<button class="account-arrow-button next-button js-next-account" type="button"><span class="visuallyhidden">View Next Account</span></button>`;
//   document.querySelector('.table-controls-dots').append(element);
//   element = document.createElement("div");
//   element.classList.add('ctaBlock');
//   document.querySelector('.table-container').insertBefore(element, document.querySelector('.table-controls-dots'));
// }
// function turnOnDotArrows() {
//   document.querySelector('.js-table-controls-dots .js-next-account').addEventListener('click', () => {
//     document.querySelector('.js-table-container .js-next-account').click();
//   })
//   document.querySelector('.js-table-controls-dots .js-prev-account').addEventListener('click', () => {
//     document.querySelector('.js-table-container .js-prev-account').click();
//   })
// }
function tablePrev(t, e) {
	let n = e - 1,
		i = t.querySelectorAll("table tr:first-child > *").length;
	0 == n && (n = i - 1), tableSwitch(t, n);
}
function tableNext(t, e) {
	let n = e + 1;
	n == t.querySelectorAll("table tr:first-child > *").length && (n = 1),
		tableSwitch(t, n);
}
function tableSwitch(t, e) {
	t.querySelectorAll("th, td").forEach(function (t, e) {
		t.classList.remove("active");
	}),
		t
			.querySelectorAll("tr > *:nth-child(" + (parseInt(e) + 1) + ")")
			.forEach(function (t, e) {
				t.classList.add("active");
			});
	let n = t.querySelectorAll(".js-carousel-dot");
	n.forEach(function (t, e) {
		t.classList.remove("is-active");
	}),
		n[e - 1].classList.add("is-active"),
		t.setAttribute("data-current-position", e),
		(t.querySelector(".js-account-title").innerText = t.querySelector(
			"tr:first-child > *:nth-child(" + (parseInt(e) + 1) + ")"
		).innerText);
	populateCTABlock();
}
// function populateCTABlock() {
//   const block = document.querySelector('.ctaBlock');
//   const lastRow = document.querySelector("table tr:last-child");
//   block.innerHTML = lastRow.querySelector('.active').innerHTML;
//   lastRow.style.display = 'none';
// }
"" !== URLHASH &&
	(hashAccordionButton = document.querySelector(
		URLHASH + " > .js-accordion-button"
	)),
	"" !== URLHASH &&
		"" !== hashAccordionButton &&
		null !== hashAccordionButton &&
		"none" !== hashAccordionButton.style.display &&
		"none" !== getComputedStyle(hashAccordionButton).display &&
		hashAccordionButton.click(),
	(window.onload = function (t) {
		"" != window.location.hash &&
			null !=
				document.getElementById(window.location.hash.substring(1)) &&
			window.setTimeout(function () {
				document
					.getElementById(window.location.hash.substring(1))
					.scrollIntoView({
						behavior: "smooth",
					});
			}, 600);
	}),
	initComparisonTables();

//show tour item in footer if needed

document.addEventListener("DOMContentLoaded", () => {
	if (document.querySelector(".tour")) {
		document.querySelector(".tourFooter").style.display = "grid";
	}
});

document.querySelector(".replay-btn").addEventListener("click", () => {
	document.cookie =
		"tourDismissed=true; expires=Fri, 31 Dec 1970 23:59:59 GMT; SameSite=None; Secure";
	document.location.reload();
});

//Location Search
var locSearch = document.querySelector(".input-search-branch");
if (locSearch) {
	locSearch.addEventListener(
		"click",
		function (e) {
			e.preventDefault();
			var inp = document.querySelector("#location-search-branch");
			loadAddress(encodeHTML(inp.value));
			console.log("Search Successful");
		},
		false
	);
}

const searchForm = document.querySelector("#location-search-form");
if (searchForm) {
	searchForm.addEventListener("submit", (e) => {
		e.preventDefault();
		var inp = document.querySelector("#location-search-branch");
		loadAddress(encodeHTML(inp.value));
		console.log("Search Successful");
	});
}

if (searchForm) {
	function loadAddress(address) {
		var geocoder = new google.maps.Geocoder();
		geocoder.geocode(
			{
				address: address,
			},
			function (results, status) {
				if (status == google.maps.GeocoderStatus.OK) {
					console.log("Address Found");
					var coords = results[0].geometry.location;
					sortBranches(coords.lat(), coords.lng());
				} else {
					console.log("Address Not Found");
				}
			}
		);
	}
}

const featureContainer = document.querySelector(".wp-block-lazyblock-feature-header");

if (featureContainer) {
	const title = featureContainer.querySelector('.f-h1');
	const copy = featureContainer.querySelector('.copy p');
	const actions = featureContainer.querySelector('.actions');

	if (!title.innerHTML.trim() && !copy.innerHTML.trim() && !actions.innerHTML.trim()) {
		console.log(title.parentNode);
		title.parentNode.style.display = "none";
	}
}

// Account chooser code
function acDeclineQuestion(el) {
	let currentAccountChooser = el.closest(".js-account-chooser-area");
	let allQuestions = currentAccountChooser.querySelectorAll(".js-ac-question");
	let currentQuestion = currentAccountChooser.querySelector(".js-ac-question.active");
	let currentResult = currentAccountChooser.querySelector(".js-ac-result.active");
	let currentIndex = Array.prototype.indexOf.call(allQuestions, currentQuestion);
	let prevButton = el;
	let nextButton = el.nextElementSibling;

	// Handle the button display first before changing which element is active.
	if(currentQuestion == allQuestions[1]) {
		prevButton.classList.add("inactive");
	} else {
		if(prevButton.classList.contains("inactive")) {
			prevButton.classList.remove("inactive");
		}
	}
	if(nextButton.classList.contains("inactive")) {
		nextButton.classList.remove("inactive");
	}

	if(null === currentQuestion) {
		// We must be on an answer, go back to questions.
		acHideItem(currentResult);
		acShowItem(allQuestions[(allQuestions.length - 1)]);
	} else {
		if(currentQuestion == allQuestions[1]) {
			acHideItem(currentQuestion);
			acShowItem(allQuestions[0]);
		} else {
			acHideItem(currentQuestion);
			acShowItem(allQuestions[(currentIndex - 1)]);
		}
	}
}
function acAdvanceQuestion(el) {
	let currentAccountChooser = el.closest(".js-account-chooser-area");
	let errorContainer = currentAccountChooser.querySelector("p.error-container");
	let allQuestions = currentAccountChooser.querySelectorAll(".js-ac-question");
	let currentQuestion = currentAccountChooser.querySelector(".js-ac-question.active");
	let aResult = currentAccountChooser.querySelector(".js-ac-result");
	let currentIndex = Array.prototype.indexOf.call(allQuestions, currentQuestion);
	let prevButton = el.previousElementSibling;
	let nextButton = el;

	if(null != currentQuestion && acCheckAnswer(currentQuestion)) {
		// Handle the button display first before changing which element is active.
		if(prevButton.classList.contains("inactive")) {
			prevButton.classList.remove("inactive");
		}
		if(currentQuestion == allQuestions[(allQuestions.length - 1)]) {
			nextButton.classList.add("inactive");
		} else {
			if(nextButton.classList.contains("inactive")) {
				nextButton.classList.remove("inactive");
			}
		}

		if(currentQuestion == allQuestions[(allQuestions.length - 1)]) {
			acHideItem(currentQuestion);
			acShowItem(aResult);
		} else {
			acHideItem(currentQuestion);
			acShowItem(allQuestions[(currentIndex + 1)]);
		}
	} else {
		acDisplayError(errorContainer);
	}
}
function acHideItem(el) {
	el.classList.remove("active");
}
function acShowItem(el) {
	el.classList.add("active");
}
function acCheckAnswer(el) {
	if(null == el.querySelector('input:checked')) {
		return false;
	} else {
		return true;
	}
}
function acDisplayError(el) {
	el.classList.add("active");
}
function acClearError(el) {
	let currentAccountChooser = el.closest(".js-account-chooser-area");
	let errorContainer = currentAccountChooser.querySelector("p.error-container");
	if(errorContainer.classList.contains("active")) {
		errorContainer.classList.remove("active");
	}
}